import { FORM_INVALID_TRANSITION_UPLOADD_OCUMENTS, FORM_VALID_TRANSITION_UPLOADD_OCUMENTS, UPLOAD_DOCUMENTS_FILE_SET_VALID, UPLOAD_DOCUMENTS_SET_VALUE } from '../../actions/kaMetlhaFuneralClaim/uploadDocuments';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initUploadDocuments = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        deathCertificate:{ fileName: null, fileContaint: null, error: null, status: null ,file: null},
        proofOfBanking: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        beneficiaryId: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        proofOfAddress: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        // confirmationOfBankAccount: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        affidavitRelation: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        claimantsId: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        affidavitSurname: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        marriageCertificate: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        marriageAffidavit: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        childBirthCertificate: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
        policeReport: { fileName: null, fileContaint: null, error: null, status: null ,file: null},
    },
};
// const initialAction={type:"",value:{fieldType:"",value:""}}
export default (state = initUploadDocuments, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
        switch (action.type) {
            case FORM_VALID_TRANSITION_UPLOADD_OCUMENTS:
                return { ...state, formStatus: FORM_STATUS.VALID };
            case FORM_INVALID_TRANSITION_UPLOADD_OCUMENTS:
                return { ...state, formStatus: FORM_STATUS.INVALID };
            case UPLOAD_DOCUMENTS_SET_VALUE:
                const {value}=action
                return updateFormField(value.fieldType, (field) => ({
                    ...field,
                    fileName: value.fileName,
                    fileContaint: value.fileContaint,
                    file: value.file
                  }));

            case UPLOAD_DOCUMENTS_FILE_SET_VALID:
                const {fieldType,error}=action
                return updateFormField(fieldType, (field) => ({
                    ...field,
                    error: error,
                    status: mapError(error),
                  }));
            default:
                return state;
        // }
    } 
};
